<script lang="ts" setup>
import type { PodcastsSearchResponse } from '~/server/api/podcasts/index.types'

const query = computed(() => useRoute().query)

const { data: podcasts } = useApi<PodcastsSearchResponse>('podcasts', {
  key: 'podcasts-search-results-' + query.value.query,
  query,
})
</script>

<template>
  <MediaListRow :items="podcasts?.data" title="Podcasts" type="podcasts" />
</template>

<style scoped></style>
